<template>
  <div id="app">
    <!--<transition name="fade" enter-active-class="animated fadeInUpBig" leave-active-class="animated fadeOutDownBig">-->
      <!--<router-view></router-view>-->
    <!--</transition>-->
    <transition name="fade">
      <router-view></router-view>
    </transition>
      <Footer></Footer>
  </div>
</template>
<script>
    import Footer from './v1/components/Footer'

    export default {
        components: {Footer},
        data() {
            return {
                isFullPage: true,
                loadingComponent: {}
            }
        },
        provide() {
            return {
                toastWarning: this.toastWarning,
                openLoading: this.openLoading,
                closeLoading: this.closeLoading,
                formatPrice: this.formatPrice
            }
        },
        methods: {
            toastWarning(message, position, type) {
                this.$toast.open({
                    duration: 3000,
                    message: message,
                    position: position,
                    type: type,
                    queue: false
                })
            },
            openLoading() {
                this.loadingComponent = this.$loading.open({
                    container: this.isFullPage ? null : this.$refs.element.$el
                })
            },
            closeLoading() {
                this.loadingComponent.close()
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(0).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "  ")
            },
        }
    }
</script>
<style>
  @import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css";
</style>